import {IonBadge, IonCheckbox, IonCol, IonIcon, IonInput, IonNote, IonRouterLink} from "@ionic/react";
import styles_TokenEnwItem from "./CheckableTokenEnwItem.module.scss";
import styles_TokenItem from "./CheckableTokenItem.module.scss";

import {star} from "ionicons/icons";
import Ln_ContractPictureSetCoverImg from "../pages/Ln_ContractPictureSetCoverImg";
import Ln_TokenPictureSetCoverImg from "../pages/Ln_TokenPictureSetCoverImg";
import {ActionLink} from "./ActionLink";
import {useEffect, useState} from "react";


export const CheckableTokenEnwItem = ({parentForceRender = null as any, Item_TokenEnwItem, field, defaultChecked = false, fromHome = false}) => {
    let [checked, setChecked] = useState(defaultChecked);

    useEffect(() => {
        if (checked) {
            field.checkedList.current.push(Item_TokenEnwItem.TokenEnwId);
        } else {
            field.checkedList.current = field.checkedList.current.filter(r => r != Item_TokenEnwItem.TokenEnwId);
        }
        parentForceRender?.();
    }, [checked]);

    let Item_Token: any = Item_TokenEnwItem?._Token;
    if (!Item_Token) {
        return <>(ERROR:Item_Token)</>;
    }

    const handleChange = async (e) => {
        const tempValue = await e.currentTarget.checked;
        setChecked(tempValue);
    };

    //        <ActionLink link={`/tabs/2_3/${Item_TokenEnwItem.TokenEnwId}`}>
    //        </ActionLink>
    return (

        <div className={styles_TokenItem.container}>
            <div className={styles_TokenItem.coverImg}>
                {Ln_TokenPictureSetCoverImg({
                    圖片組: Item_Token.圖片組,
                    名稱: 'cover',
                })}
            </div>
            {/*<div className={`${styles.stackBadge}`}>100+</div>*/}
            <div className={`${styles_TokenItem.productTitleContainer}`}>
                <div>
                    <h1 className={`${styles_TokenItem.productTitle} truncate`}>{Item_Token.名稱}</h1>
                </div>

                <div className="last">
                    {/*<div className="line"/>*/}
                    {/*<div className="lowestPrice">*/}
                    {/*    &nbsp;*/}
                    {/*</div>*/}
                    <div className="right">
                        <div>
                            <IonCheckbox onIonChange={handleChange} checked={checked}></IonCheckbox> 版號: {Item_TokenEnwItem.Edition}
                        </div>
                        {/*<div className={styles_TokenItem.productRating}>*/}
                        {/*    <IonNote>*/}
                        {/*        <IonIcon icon={star}/>*/}
                        {/*    </IonNote>*/}
                        {/*    <IonNote>*/}
                        {/*        {5}*/}
                        {/*    </IonNote>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </div>
        </div>

    );
}
